import React from 'react';
export const LogoUalaBis = ({ width, style }) => (
  <img
    style={style}
    width={width}
    src="https://dk0k1i3js6c49.cloudfront.net/panel/medios_pago/uala-card-img.png"
  />
);
